// extracted by mini-css-extract-plugin
export var content = "_m6-1";
export var divider = "_m6-0";